// extracted by mini-css-extract-plugin
module.exports = {"mainContainerWidget":"_385snsL7","childContainerWidget":"NI30v8c3","loader":"_2lCuj6Ah"};